import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { startSiteSession } from './utils/siteEvents';

// Antes de qualquer redirecionamento do SPA tirar gclid/utm da URL.
startSiteSession();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
); 
